import axios from 'axios';

const { apiHost = '' } = window.katalisConfig || {};
const wootAPI = axios.create({ baseURL: `${apiHost}/` });

export default wootAPI;
